import api from '@/services/api';

const url = 'plan';

const save = plans => api.post(`${url}/create-plan`, plans);

const deleteOne = id => api.delete(`${url}/delete-plan/${id}`);

export default { save, deleteOne };
